import { Link } from 'react-router-dom'
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types'

import './footer.css'
// const mapCategories = (categories) => {
//   return categories.map(category => (
//     <a href={`Aktuelle?category=${category.name}`} key={category.id}>
//       <div className="footer-link">
//         <span>{category.name}</span>
//       </div>
//     </a>
//   ));
// };
const Footer = (props) => {

// const [categories, setCategories] = useState([]);
// useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         // const res = await fetch(`${process.env.REACT_APP_API_URL}/api/categories`);
//         const res = await fetch('http://127.0.0.1:1337/api/categories');
//         const data = await res.json();

//         if (data.data) {
//           const mappedCategories = data.data.map((category) => ({
//             id: category.id,
//             name: category.name,
//             slug: category.slug,
//           }));
//           setCategories(mappedCategories);
//         }
//       } catch (error) {
//         console.error('Error fetching categories:', error);
//       }
//     };

//     fetchCategories();
//   }, []);
  return (
    <div className={`footer-container1 ${props.rootClassName} `}>
      <footer className="footer">
        <div className="footer-diagonal-accent"></div>
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-column footer-column-brand">
              <div className="footer-logo">
                <h2 className="section-title">Stimme Georgiens</h2>
                <p className="footer-tagline">
                  Stimme Georgiens - Unabhängige Nachrichten &amp; Medien
                </p>
              </div>
              <div className="footer-mission section-content" style={{ display: 'flex', flexWrap: 'wrap' }}>
                <div style={{ flex: '1 1 50%' }}>
                  <p>
                    <Link className="footer-link" to="/">Startseite</Link><br/>
                    <Link className="footer-link" to="/ueber-uns">Über uns</Link><br/>
                    
                  </p>
                </div>
                <div style={{ flex: '1 1 50%' }}>
                  <p>
                    {/* <Link className="footer-link" to="/mitmachen">Mitmachen</Link><br/> */}
                    {/* <Link className="footer-link" to="/kontakt">Kontakt</Link><br/> */}
                    <Link className="footer-link" to="/datenschutz">Datenschutz</Link><br/>
                    <Link className="footer-link" to="/impressum">Impressum</Link>
                  </p>
                </div>
              </div>
              <div className="footer-social">
                <a
                  href="https://www.facebook.com/profile.php?id=61583646155809"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label="Facebook"
                    className="footer-social-link"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                </a>
                <a
                  href="https://signal.group/#CjQKIOGf_QSXto_SBFKuLVtpsLPhWU7DR72ma-GP34ahf8caEhAvxKJGhqLbuIBxicfPr8Up"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label="Instagram"
                    className="footer-social-link"
                  >
                    <img
                      src="/media/Signal-Logo-Ultramarine.svg"
                      alt="Signal"
                      width="24"
                      height="24"
                    />
                  </div>
                </a>
                {/* <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label="YouTube"
                    className="footer-social-link"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M2.5 17a24.1 24.1 0 0 1 0-10a2 2 0 0 1 1.4-1.4a49.6 49.6 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.1 24.1 0 0 1 0 10a2 2 0 0 1-1.4 1.4a49.6 49.6 0 0 1-16.2 0A2 2 0 0 1 2.5 17"></path>
                        <path d="m10 15l5-3l-5-3z"></path>
                      </g>
                    </svg>
                  </div>
                </a> */}
              </div>
            </div>
            {/* <div className="footer-column footer-column-links">
              <h3 className="footer-column-title">Themen Kategorien</h3>
              <nav className="footer-nav">
                {mapCategories(categories)}
              </nav>
            </div> */}
            <div className="footer-column footer-column-contact">
              <h3 className="footer-column-title">Kontaktieren Sie uns</h3>
              <div className="footer-contact-group">
                <div className="footer-contact-item">
                  <div className="footer-icon-wrapper">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M17.97 9.304A8 8 0 0 0 2 10c0 4.69 4.887 9.562 7.022 11.468m12.356-4.842a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"></path>
                        <circle r="3" cx="10" cy="10"></circle>
                      </g>
                    </svg>
                  </div>
                  <div className="footer-contact-info">
                    <span className="footer-contact-label">Adresse</span>
                    <span className="footer-contact-value">Tornike Svanidze: Kaiser-Joseph-Straße 172, 79098, Freiburg</span>
                  </div>
                </div>
                <div className="footer-contact-item">
                  <div className="footer-icon-wrapper">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                  <div className="footer-contact-info">
                    <span className="footer-contact-label">Telefon</span>
                    <a href="tel:+995123456789">
                      <div className="footer-contact-value footer-contact-link">
                        <span>+49 176 70910063</span>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="footer-contact-item">
                  <div className="footer-icon-wrapper">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                      </g>
                    </svg>
                  </div>
                  <div className="footer-contact-info">
                    <span className="footer-contact-label">E-Mail</span>
                    <a href="mailto:info@stimmegeorgiens.ge?subject=">
                      <div className="footer-contact-value footer-contact-link">
                        <span>info@stimmegeorgiens.de</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="footer-messaging">
                <span className="footer-messaging-label">
                  Schreiben Sie uns eine Nachricht
                </span>
                <div className="footer-messaging-links">
                <a
                  href="https://signal.me/#p/0176 70910063"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label="Signal"
                    className="footer-messaging-btn"
                  >
                    <img
                      src="/media/Signal-Logo-Ultramarine.svg"
                      alt="Signal"
                      width="24"
                      height="24"
                    />
                    <span>Signal</span>
                  </div>
                </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

Footer.defaultProps = {
  rootClassName: '',
}

Footer.propTypes = {
  rootClassName: PropTypes.string,
}

export default Footer
